module.exports = __webpack_public_path__ + "static/media/logo-camaracampoformoso.b43445f8.png";